import { createContext, useContext } from 'react';
import { ReportFilters } from '@views/pages/Reporting/Reports/types.ts';

type ReportingContextType = {
  filters: ReportFilters;
  handleFilterChange: (filters: Partial<ReportFilters>) => void;
  handleResetFilters: () => void;
  isInitialFilters: boolean;
};

export const ReportingContext = createContext<ReportingContextType | null>(
  null,
);

export const useReportingContext = () => {
  const context = useContext(ReportingContext);
  if (!context) {
    throw new Error(
      'The useReportingContext hook must be used within a ReportingContextProvider.',
    );
  }
  return context;
};
